export default "__VITE_ASSET__uKd5w7QT__"